export const PRICE_FORMAT = '$0,0'
